//  Flash Cards Data
export const questions = [
  {
    id: 3457,
    question: 'What language is React based on?',
    answer: 'JavaScript',
  },
  {
    id: 7336,
    question: 'What are the building blocks of React apps?',
    answer: 'Components',
  },
  {
    id: 8832,
    question: "What's the name of the syntax we use to describe a UI in React?",
    answer: 'JSX',
  },
  {
    id: 1297,
    question: 'How to pass data from parent to child components?',
    answer: 'Props',
  },
  {
    id: 9103,
    question: 'How to give components memory?',
    answer: 'useState hook',
  },
  {
    id: 2002,
    question:
      'What do we call an input element that is completely synchronised with state?',
    answer: 'Controlled element',
  },
];

//  Accordian Data
export const faqs = [
  {
    title: 'What is the Virtual DOM in React?',
    text: 'The Virtual DOM is a lightweight representation of the real DOM. React uses the Virtual DOM to optimize updates by first applying changes to the Virtual DOM and then efficiently updating the real DOM only where necessary. This process improves performance and makes rendering faster.',
  },
  {
    title: 'What are hooks in React?',
    text: 'Hooks are functions that let you "hook into" React state and lifecycle features from function components. Examples include useState for managing state and useEffect for side effects like data fetching or subscribing to services.',
  },
  {
    title: 'What is the purpose of useEffect in React?',
    text: "useEffect is a hook that lets you perform side effects in function components. It serves the same purpose as lifecycle methods like componentDidMount, componentDidUpdate, and componentWillUnmount in class components. It's commonly used for data fetching, subscriptions, and manual DOM manipulations.",
  },

  {
    title: 'What is the purpose of key props in React?',
    text: 'The key prop is used to uniquely identify elements in an array. It helps React optimize rendering by tracking changes, additions, and removals of elements efficiently. Keys should be stable, unique, and consistent across renders to ensure proper component identity.',
  },
  {
    title: 'What are React components?',
    text: 'React components are the building blocks of a React application. They can be either class components or function components. Components let you split the UI into independent, reusable pieces, and think about each piece in isolation.',
  },
  {
    title: 'What is the difference between state and props in React?',
    text: 'In React, state is a built-in object that stores property values that belong to a component. It is mutable and can be changed with setState. Props, short for properties, are read-only attributes passed from a parent component to a child component, used to pass data and event handlers to child components.',
  },
];
